import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=38b40252&scoped=true&"
import script from "./Window.vue?vue&type=script&lang=ts&"
export * from "./Window.vue?vue&type=script&lang=ts&"
import style0 from "./Window.vue?vue&type=style&index=0&id=38b40252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b40252",
  null
  
)

export default component.exports